import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons'
import { Grid, Button, Card } from '@softwaredev_cegeka/stix-core'
import { withNotifier } from '@softwaredev_cegeka/stix-notifier'

import withUserData from 'src/components/auth/withUserData'

import sky from '../../assets/images/sky.svg'
import clouds from '../../assets/images/clouds.svg'

import './footer.scss'

class Footer extends Component {
    render() {
        return (
            <footer>
                <Grid.Container>
                    <Card>
                        <Card.Body>
                            <div className="card-body">
                                <img
                                    className="clouds"
                                    src={clouds}
                                    alt="clouds"
                                />
                                <img className="sky" src={sky} alt="sky" />
                                <div className="card-text">
                                    <span>How can we help?</span>
                                    <br />
                                    Do you have any questions or are you
                                    experiencing a problem?
                                    <br />
                                    Feel free to reach out and we'll get back to
                                    you as soon as possible.
                                </div>
                                <Button
                                    variant="secondary"
                                    size="lg"
                                    href="https://horizon.cegeka.com/create-ticket"
                                >
                                    <div className="create-ticket-label">
                                        <span>Create ticket</span>
                                        <FontAwesomeIcon icon={faArrowRight} />
                                    </div>
                                </Button>
                            </div>
                        </Card.Body>
                    </Card>
                </Grid.Container>
                <div className="footer-bottom">
                    <Grid.Container>
                        <ul className="footer-bottom-links">
                            <li>
                                <span className="disclaimer">
                                    ©{new Date().getFullYear()} Cegeka. All
                                    rights reserved
                                </span>
                            </li>
                            <li>
                                <span className="version">version 1.0.0</span>
                            </li>
                        </ul>
                    </Grid.Container>
                </div>
            </footer>
        )
    }
}

export default withNotifier(withUserData(Footer))
